import { call, put } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'
import {
  addSyncTargets as addSyncTargetsToUserGroup
} from 'store/redux/userGroups'

export default function * requestAddSyncTargetToUserGroup (action) {
  const { groupId, identifier, args } = action.payload

  const SyncTarget = yield call(apiAction, 'AddSyncTarget', {
    groupId,
    identifier,
    args
  })

  yield put(addSyncTargetsToUserGroup({
    id: groupId,
    syncTargets: [{
      id: SyncTarget.Id,
      name: SyncTarget.Name
    }]
  }))
}
